export default {
    apiKey: "AIzaSyD9DihKwjfIL7HuDPv_0LIJf6XiZgV4k3g",
    authDomain: "newface-dolores.firebaseapp.com",
    databaseURL: "https://newface-dolores.firebaseio.com",
    projectId: "newface-dolores",
    storageBucket: "newface-dolores.appspot.com",
    messagingSenderId: "974266040465",
    appId: "1:974266040465:web:64cf114e714622a9b5ff30"
  }